import { render, staticRenderFns } from "./base-pre-login.vue?vue&type=template&id=15257c37&scoped=true&"
import script from "./base-pre-login.vue?vue&type=script&lang=js&"
export * from "./base-pre-login.vue?vue&type=script&lang=js&"
import style0 from "./base-pre-login.vue?vue&type=style&index=0&id=15257c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15257c37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
